<template>
  <div v-if="show" class="row">
    <div
      v-for="key in numberOfItens || 8"
      :key="Number(key)"
      class="col-md-3 col-6 pb-2"
    >
      <skeleton-card
        style="margin: 0 5% 0 5%"
        is-loading
        round
        :avatar="false"
      />
    </div>
  </div>
</template>

<script>
import SkeletonCard from 'vue-skeleton-screen'

export default {
  name: 'SkeletonCardList',
  components: { SkeletonCard },
  props: {
    show: Boolean,
    numberOfItens: Number,
  },
}
</script>
